<template>
  <div>
    <div style="margin-bottom: 15px; font-weight: bold">订单最近三笔挂账变动记录</div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="reserveTypeName" label="变动类型" />
        <el-table-column prop="amount" label="变动金额">
          <template slot-scope="scope">
            <span v-if="scope.row.amountType === 1" style="color: #67C23A; font-weight: bold;">
              {{ "+" + scope.row.amount }}
            </span>
            <span v-else style="color: #F56C6C; font-weight: bold;">
              {{ "-" + scope.row.amount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="beforeAmount" label="变动前金额" />
        <el-table-column prop="afterAmount" label="变动后金额" />
        <el-table-column prop="createTime" label="变动时间" width="180px" />
        <el-table-column prop="actionUserName" label="操作人" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { getListAPI } from "./api";

export default {
  name: "OrderReserveList",

  props: {
    pageSize: {
      type: Number,
      default: 3,
    },
    orderNo: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      tableData: [],
    };
  },

  watch: {
    orderNo: {
      handler(newVal) {
        if (!newVal) {
          return;
        }

        this.getTableData();
      },
    },
  },

  mounted() {
    this.getTableData();
  },

  methods: {
    async getTableData() {
      if (!this.orderNo) {
        return;
      }

      const res = await getListAPI({
        page: 1,
        pageSize: this.pageSize,
        orderNo: this.orderNo,
      });

      this.tableData = res.list;
    },
  },
};
</script>
